import { gql } from '@apollo/client'

export const POINT_OF_INTEREST_FRAGMENT = gql`
  fragment PointOfInterest on PicOSPOI {
    name
    id
    displayTypes {
      name
      id
    }
    displayLocations {
      name
      id
    }
  }
`
